module.exports = __webpack_public_path__ + "img/business-activity-factory.c67a5048.svg";